/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cross': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" _fill="#EF7D01" fill-rule="evenodd" d="M1.19 0a1.188 1.188 0 00-.84 2.03L2.818 4.5.349 6.97A1.188 1.188 0 102.03 8.65l2.47-2.47 2.47 2.47a1.186 1.186 0 001.681 0 1.188 1.188 0 000-1.681L6.181 4.5l2.47-2.47A1.188 1.188 0 106.97.35L4.5 2.819 2.03.349A1.185 1.185 0 001.19 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/cross.js